import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { questionAnswered, questionNotAnswered, questionErrored } from 'actions/questionnaires';
import questionProp from 'common/questionnaires/questionDataProp';
import { Mode } from 'common/questionnaires/types';

const QuestionButton = ({ isForm, titles, buttonCount, question: { answer, id, inputs, name }, dispatch, mode, runValidation }) => {
  const getButtonClass = (buttonIndex) => {
    let buttonClass = `btn questionnaire-button ${ (answer === buttonIndex) ? 'selected' : '' }`;
    if (buttonCount && buttonCount === 2) {
      buttonClass += ' small';
    } else if (buttonCount && buttonIndex % 2 === 0) {
      buttonClass += ' left';
    }

    return buttonClass;
  };

  const validateQuestion = () => {
    const isRequired = inputs && inputs.required;
    if (answer === null || answer === undefined) {
      if (isRequired) {
        dispatch(questionErrored({ id, mode, isForm }));
      } else {
        dispatch(questionNotAnswered({ id, mode, isForm }));
      }
    }
  };

  useEffect(() => {
    if (runValidation) {
      validateQuestion();
    }
  }, [runValidation]);

  return (<div className="button-container" id={ id }>
    {titles.map((title, i) => <button
      key={ title }
      className={ getButtonClass(i) }
      type="button"
      onClick={ () => dispatch(questionAnswered({ id, answer: i, mode, isForm, name })) }
    >{title}</button>)}
  </div>);
};

QuestionButton.propTypes = {
  isForm: PropTypes.bool,
  titles: PropTypes.arrayOf(PropTypes.string).isRequired,
  question: questionProp.isRequired,
  dispatch: PropTypes.func.isRequired,
  buttonCount: PropTypes.number.isRequired,
  runValidation: PropTypes.bool,
  mode: PropTypes.number
};

QuestionButton.defaultProps = {
  isForm: false,
  mode: Mode.Crs,
  runValidation: false
};

const mapDispatchToProps = dispatch => ({ dispatch });

const mapStateToProps = (state) => {
  const {
    app: { onlineConfig },
    formQuestionnaire: { runValidation }
  } = state;

  return {
    mode: onlineConfig && onlineConfig.preQualifyingQuestionnaireMode,
    runValidation
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionButton);
